module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/ef58e8659db0e25422077e2c25ba54bc.png";